import { render, staticRenderFns } from "./myAgentTeam.vue?vue&type=template&id=5c580c06&scoped=true&"
import script from "./myAgentTeam.vue?vue&type=script&lang=js&"
export * from "./myAgentTeam.vue?vue&type=script&lang=js&"
import style0 from "./myAgentTeam.vue?vue&type=style&index=0&id=5c580c06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c580c06",
  null
  
)

export default component.exports